/**
 *
 */

function parseAttrs(str) {
  const attrs = [];
  const re = /([\w-]+)\s*=\s*("([^"]*)"|'([^']*)'|([^\s}]+))/g;
  let m;
  // eslint-disable-next-line no-cond-assign
  while ((m = re.exec(str)) !== null) {
    const value = m[3] ?? m[4] ?? m[5] ?? '';
    attrs.push([m[1], value]);
  }
  return attrs;
}

const IMG_WITH_ATTRS_RE = /!\[([^\]]*)\]\(([^)]+)\)\s*\{([^}]*)\}/g;

export default function markdownItImgAttrs(md) {
  function transform(src) {
    if (!src || typeof src !== 'string') return src;
    return src.replace(IMG_WITH_ATTRS_RE, (match, alt, url, attrStr) => {
      const attrs = parseAttrs(attrStr);
      const safeUrl = md.utils.escapeHtml(String(url).trim());
      const safeAlt = md.utils.escapeHtml(alt);
      const extra = attrs
        .filter(([k]) => /^[\w-]+$/.test(k))
        .map(([k, v]) => ` ${k}="${md.utils.escapeHtml(String(v))}"`)
        .join('');
      return `<img src="${safeUrl}" alt="${safeAlt}"${extra} />`;
    });
  }

  const origRender = md.render.bind(md);
  md.render = (src, env) => {
    return origRender(transform(src), env);
  };

  if (typeof md.renderInline === 'function') {
    const origRenderInline = md.renderInline.bind(md);
    md.renderInline = (src, env) => {
      return origRenderInline(transform(src), env);
    };
  }
}
